<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    watch: {
      $route(to, from) {
        // console.log('route change to', to);
        // console.log('route change from', from);
        this.$store.commit('registrarUltPaginaVisitada', from.name)
      },
    },
  }
</script>

